import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('REFERRAL_INFO_LIST_REQUEST')